import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PawPrint } from "lucide-react";
import api from "../lib/api";

export const AriAvatar = () => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    api
      .get("/profile")
      .then((r) => setProfile(r.data))
      .catch(() => setProfile({ name: "Ari", image: "" }));
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8, y: 10 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="mb-7 flex items-center gap-4"
      data-testid="ari-avatar"
    >
      <span className="relative inline-flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-full bg-sand ring-2 ring-marmalade ring-offset-2 ring-offset-cream md:h-20 md:w-20">
        {profile?.image ? (
          <img src={profile.image} alt={`${profile.name || "Ari"}, your pet sitter`} className="h-full w-full object-cover" />
        ) : (
          <PawPrint className="h-8 w-8 text-marmalade" fill="currentColor" strokeWidth={0} />
        )}
      </span>
      <span className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.25em] text-inkSoft">
        {profile?.name || "Ari"} — your one &<br className="hidden sm:block" /> only sitter, in the fur
      </span>
    </motion.div>
  );
};

export default AriAvatar;
